<template>
  <div :class="['guide-panel', `guide-panel--${tone}`, { 'guide-panel--dense': dense }]">
    <div class="guide-panel__accent"></div>
    <div v-if="title" class="guide-panel__title">
      <span class="guide-panel__title-icon">
        <i :class="icon"></i>
      </span>
      <span>{{ title }}</span>
    </div>
    <div v-if="summary" class="guide-panel__summary" v-html="summary"></div>
    <div v-for="(item, index) in points" :key="index" class="guide-panel__point">
      <span class="guide-panel__point-icon">{{ pointIcon }}</span>
      <div class="guide-panel__point-text" v-html="item"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GuidePanel",
  props: {
    title: {
      type: String,
      default: "",
    },
    summary: {
      type: String,
      default: "",
    },
    points: {
      type: Array,
      default: () => [],
    },
    tone: {
      type: String,
      default: "info",
    },
    dense: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: "el-icon-info",
    },
    pointIcon: {
      type: String,
      default: "•",
    },
  },
};
</script>

<style scoped>
.guide-panel {
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  padding: 12px 14px 11px;
  border: 1px solid #e2ebf8;
  background: linear-gradient(180deg, #fafcff 0%, #f4f8ff 100%);
  color: #304156;
  box-shadow: 0 2px 8px rgba(31, 42, 68, 0.04);
}

.guide-panel__accent {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: linear-gradient(90deg, #7fb0ff 0%, #bfd6ff 100%);
}

.guide-panel--dense {
  padding: 9px 12px 8px;
}

.guide-panel--warning {
  border-color: #f6ddae;
  background: linear-gradient(180deg, #fffaf0 0%, #fff5e1 100%);
}

.guide-panel--success {
  border-color: #d6eadb;
  background: linear-gradient(180deg, #f8fff8 0%, #f0faf2 100%);
}

.guide-panel--warning .guide-panel__accent {
  background: linear-gradient(90deg, #f0bf62 0%, #f7dfa8 100%);
}

.guide-panel--success .guide-panel__accent {
  background: linear-gradient(90deg, #7bc698 0%, #cde9d8 100%);
}

.guide-panel__title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #1f2a44;
}

.guide-panel__title-icon {
  width: 24px;
  height: 24px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(64, 122, 255, 0.1);
  color: #4a7bff;
  flex-shrink: 0;
}

.guide-panel--warning .guide-panel__title-icon {
  background: rgba(240, 191, 98, 0.16);
  color: #c98d1d;
}

.guide-panel--success .guide-panel__title-icon {
  background: rgba(66, 185, 131, 0.12);
  color: #2d9467;
}

.guide-panel__summary {
  margin-top: 6px;
  line-height: 1.65;
  font-size: 12px;
  color: #5d6c84;
}

.guide-panel__point {
  margin-top: 6px;
  display: flex;
  align-items: flex-start;
  gap: 6px;
  line-height: 1.6;
  font-size: 12px;
}

.guide-panel__point-icon {
  min-width: 18px;
  color: #4a7bff;
  font-weight: 700;
  line-height: 1.6;
}

.guide-panel__point-text {
  flex: 1;
  color: #44546d;
}
</style>
